import React from 'react'
import ResizedImage from './ResizedImage'

interface AuthorStatementProps {
  title: string
  children: React.ReactNode
  image: string
  author: string
}

const AuthorStatement: React.FC<AuthorStatementProps> = ({
  title,
  children,
  image,
  author,
}) => {
  return (
    <div className="my-8 grid grid-cols-[auto_1fr] gap-4 md:gap-6">
      {/* Image - spans 1 row on mobile, 2 rows on desktop */}
      <div className="w-24 h-24 sm:w-28 sm:h-28 md:w-32 md:h-32 lg:w-40 lg:h-40 rounded-xl overflow-hidden shadow-lg row-span-1 md:row-span-2">
        <ResizedImage
          src={image}
          alt={author}
          sizes="(max-width:768px) 96px, (max-width:1024px) 128px, 160px"
          wrapperStyle={{
            position: 'relative',
            width: '100%',
            height: '100%',
            paddingTop: '0', // disable default aspect padding
          }}
          style={{ objectFit: 'cover' }}
          loading="lazy"
          preload={false}
        />
      </div>

      {/* Title and Author */}
      <div className="flex flex-col justify-center">
        <div className="mb-2">
          <span className="text-gray-600 text-sm font-semibold uppercase tracking-widest">
            {title}
          </span>
        </div>

        <h2 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold text-primary mb-0 mt-0">
          {author}
        </h2>
      </div>

      {/* Bio */}
      <div className="col-span-2 md:col-span-1 text-gray-700 text-base leading-relaxed">
        {children}
      </div>
    </div>
  )
}

export default AuthorStatement